module.exports = __webpack_public_path__ + "img/portfolio.88ff3a2f.svg";